import { CheckCircle2, Info, MinusCircle } from "lucide-react";

const MAP = {
  verified: {
    label: "Verified",
    color: "#6CC24A",
    Icon: CheckCircle2,
    description: "Every required signal for this category was measured directly from a public data source. Some optional signals may still be unavailable.",
  },
  calculated: {
    label: "Calculated",
    color: "#C7CBD1",
    Icon: Info,
    description: "Derived from Pulse Point's deterministic scoring framework.",
  },
  unavailable: {
    label: "Unavailable",
    color: "#EAB308",
    Icon: MinusCircle,
    description: "The public data source did not return a usable result for this run.",
  },
  estimated: {
    label: "Estimated",
    color: "#EAB308",
    Icon: MinusCircle,
    description: "Inferred where direct measurement is not available.",
  },
};

export default function ConfidenceBadge({
  confidence = "calculated",
  source,
  // Reuses the backend's existing roadmap_only evidence flag (see
  // CategoryCard.jsx / CategoryDetailDialog.jsx) — no new evidence
  // status, no scoring change. True means this category has at least
  // one signal that is structurally unmeasurable under the current
  // build (e.g. Reviews' recency/response-rate, Local Authority's
  // NAP/citation signals), not merely unresolved this run.
  partialScope = false,
  className = "",
}) {
  const meta = MAP[confidence] || MAP.calculated;
  const Icon = meta.Icon;
  const isPartialVerified = confidence === "verified" && partialScope;
  const label = isPartialVerified ? "Verified · Partial Scope" : meta.label;
  const description = isPartialVerified
    ? "Every currently-measurable signal in this category was verified. One or more signals in this category cannot be measured at all with today's data sources — this is not a claim that the complete category was verified."
    : meta.description;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 text-[10px] uppercase tracking-wider font-semibold border ${className}`}
      style={{
        color: meta.color,
        borderColor: `${meta.color}55`,
        background: `${meta.color}0F`,
      }}
      title={source ? `${description} · ${source}` : description}
      data-testid={`confidence-badge-${confidence}`}
      data-partial-scope={isPartialVerified ? "true" : "false"}
    >
      <Icon className="h-3 w-3" />
      {label}
    </span>
  );
}
